import { apolloClient } from '~/apollo-client';
import { PaymentMethod } from '~/typings/context';
import {
  Flex_UpdatePlanPaymentMethodMutation,
  Flex_UpdatePlanPaymentMethodMutationVariables,
} from '~/typings/graphql';
import { errors } from '~/utils/error-messages';
import { UPDATE_PLAN_PAYMENT_METHOD } from './update-plan-payment-method.queries';

export interface UpdatePlanPaymentMethodParams {
  customPlanId: number;
  paymentMethodId: number;
}

export interface UpdatePlanPaymentMethodResponse {
  paymentMethod: PaymentMethod;
}

export const updatePlanPaymentMethod = async (
  params: UpdatePlanPaymentMethodParams,
): Promise<UpdatePlanPaymentMethodResponse> => {
  const { data } = await apolloClient.mutate<
    Flex_UpdatePlanPaymentMethodMutation,
    Flex_UpdatePlanPaymentMethodMutationVariables
  >({
    mutation: UPDATE_PLAN_PAYMENT_METHOD,
    variables: {
      input: {
        paymentMethodId: params.paymentMethodId,
        planId: params.customPlanId,
      },
    },
  });

  const paymentMethod = data?.setPaymentMethod.paymentMethod;
  if (!paymentMethod) throw new Error(errors.missingUpdatePlanPaymentResponse);

  return { paymentMethod };
};
